import { AddressModel } from '../../domain/addresses';
import { Type } from 'class-transformer';

// @dynamic
export class AddressesModel {

  @Type(() => AddressModel)
  addresses: AddressModel[];
}
